import React from "react"

import classnames from "classnames"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"

import {useStyles} from "./styles"

interface HeaderProps {
    isExpanded: boolean;
    onToggleCollapse: any;
    onToggleExpand: any;
}

export const Header = (props: HeaderProps) => {

    const {isExpanded, onToggleExpand, onToggleCollapse} = props
    const styles = useStyles()

    return (
        <>
            <Icon
                icon={"icon-window-minimize1"}
                onClick={onToggleCollapse}
                className={classnames(styles.headerIcon, styles.minimizeIcon)}
            />

            <Icon
                icon={isExpanded ? "icon-shrink7" : "icon-enlarge7"}
                onClick={() => onToggleExpand(!isExpanded)}
                className={classnames(styles.headerIcon, styles.expandIcon)}
            />
        </>
    )
}